<template>
  <div>
    <h2 class="hdg03">
      <template v-if="props.parentName === 'PCContract'">既定のお支払い方法</template>
      <template v-else>お支払い方法</template>
    </h2>

    <FontawesomeIcon v-if="!paymentMethod.isLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
    <template v-else>
      <!-- 選択肢表示(「お見積もり内容の確認画面」 ＆ 「既定のお支払い方法」) -->
      <template v-if="paymentMethod.dispChoices">
        <div class="contract-content-payment">
          <p v-if="props.parentName === 'PCContract'" class="txt">
            <!-- 契約情報画面側の表示 -->
            既定のお支払い方法の変更をご希望される場合は、以下のお支払い方法を選択してください。<br>
            次回の契約更新後、選択いただいたお支払い方法が適用されます。<br>
            また、「クレジットカード」「口座振替」「銀行振込(WEB請求書)」をご利用の場合は、「新日本法規WEB会員」ログインが必要です。<br>
            詳しくは「<a href="/guide/autolc/" class="txt-blue" target="_blank">LEGAL CONNECTION自動決済サービス</a>」をご参照ください。<br>
          </p>
          <p v-else class="txt">
            <!-- お見積もり内容の確認画面側の表示 -->
            お支払い方法を選択してください。<br>
            次回の契約更新時も、このお支払い方法で実施されます。<br>
            また、「クレジットカード」「口座振替」「銀行振込(WEB請求書)」をご利用の場合は、「新日本法規WEB会員」ログインが必要です。<br>
            詳しくは「<a href="/guide/autolc/" class="txt-blue" target="_blank">LEGAL CONNECTION自動決済サービス</a>」をご参照ください。<br>
          </p>
          <div class="formparts radio contract-content-payment-flex mb40">
            <div v-for="(item, index) in paymentMethod.list" :key="'payment_method_'+ index" class="radio flex-content">
              <input type="radio" name="payment_method" :value="item.id" :id="'payment_method_' + item.id"
                v-model.number="paymentMethod.paymentClassification">
              <label role="button" :for="'payment_method_'+ item.id">{{ item.name }}</label>
            </div>
          </div>
          <p class="txt" v-if="paymentMethod.choosePaymentMethod !== 0">
            以下の必要事項についてご記入を完了してください。<br>
            ※ご記入中に新日本法規WEBサイトからログアウトあるいはタイムアウトになった場合は、新日本法規WEBサイトのログイン画面が表示されますので、再度ログインしてください。
          </p>
          <iframe v-show="paymentMethod.choosePaymentMethod === 901 && (paymentMethod.offerCodeRequestStatus === 1 || paymentMethod.offerCodeRequestStatus === '')" class="iframe -creditCard" src="/shop/account/iframe/lc/autopaymentrequest" frameborder="0"></iframe>
          <iframe v-show="paymentMethod.choosePaymentMethod === 9 && (paymentMethod.offerCodeRequestStatus === 1 || paymentMethod.offerCodeRequestStatus === '')" class="iframe -bankTransfer" src="/shop/account/iframe/lc/paymentrequest" frameborder="0"></iframe>
          <div v-if="(paymentMethod.choosePaymentMethod === 901 || paymentMethod.choosePaymentMethod === 9) && paymentMethod.offerCodeRequestStatus === 2" class="mt40 mb40">
            <h3 class="hdg03 ta-center">決済申請は完了しております</h3>
            <p class="txt txt-red txt-bold ta-center mb12">【ご注意】お申込は完了していません。</p>
            <p class="txt ta-center mb12">下記ボタンを押下してお進みください。</p>
          </div>
          <div v-if="props.parentName === 'EstimateFinalIndex' && (paymentMethod.choosePaymentMethod === 901 || paymentMethod.choosePaymentMethod === 9) && paymentMethod.offerCodeRequestStatus === 3" class="mt40 mb40 sp-ml20 sp-mr20">
            <h3 class="hdg03 ta-center">LEGAL CONNECTIONはご契約済です</h3>
            <p class="txt ta-center mb12">ログインしてご利用ください。</p>
            <p class="ta-center"><router-link :to="`/pc/login`" class="txt-blue" target="_blank">LEGAL CONNECTIONログイン</router-link></p>
          </div>
          <div v-show="paymentMethod.choosePaymentMethod === 1">
            <section class="section-suggest mt40">
              <h3 class="hdg03 ta-center mb40 mt12">新日本法規WEB会員の方はこちら</h3>
              <div class="section-suggest-content">
                <p class="txt mb12">「ログインする」ボタンを押下し、新日本法規WEBサイトへログインして「決済申請」へお進みください。</p>
                <div class="ta-center login-btn-wrp">
                  <div class="button"><a :href="paymentMethod.loginBtnUrl" @click="paymentMethod.onWebLoginClicked" class="btn login-btn">ログインする</a></div>
                </div>
              </div>
            </section>
            <section class="section-suggest mt40">
              <h3 class="hdg03 ta-center mt12">新日本法規WEB会員登録がお済みでない方はこちら</h3>
              <h3 class="ta-center txt-notice">《新規会員登録にあたっての注意事項とお願い》</h3>
              <h3 v-if="props.parentName === 'PCContract'" class="txt-notice mb32">
                下記①の「新規会員登録」ボタンより会員登録が完了されましたら、ブラウザ上部のタブ「契約情報」を押下し当ページに戻り、②の「決済申請」を押下してお進みください。<br>
              </h3>
              <h3 v-else class="txt-notice mb32">
                下記①の「新規会員登録」ボタンより会員登録が完了されましたら、ブラウザ上部のタブ「お見積もり内容の確認」を押下し当ページに戻り、②の「決済申請」を押下してお進みください。<br>
              </h3>
              <div class="section-suggest-content">
                <p class="txt mb12">①「新規会員登録」ボタンを押下し、新日本法規WEB会員新規登録を行ってください。</p>
                <div class="ta-center login-btn-wrp mb40">
                  <div class="button"><a href="/shop/signup" target="_blank" class="btn login-btn">新規会員登録<FontawesomeIcon icon="external-link-alt" class="icn" /></a></div>
                </div>
              </div>
              <div class="section-suggest-content">
                <p class="txt">②新日本法規WEB会員登録後、「決済申請」を押下してお申し込みください。</p>
                <div class="ta-center">
                  <div class="ta-center">
                    <div class="button login-btn"><a href="javascript:void(0)" class="txt-blue" @click="paymentMethod.onWebLoginCheckClicked()">決済申請</a></div>
                    <p class="txt-error" v-if="paymentMethod.isWebSessionFetched && !paymentMethod.isWebSessionExist">新日本法規WEB会員にログインしておりません。</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <p class="error-message" v-if="paymentMethod.error_orderCode">{{ paymentMethod.error_orderCode }}</p>
        </div>
        <div class="contract-submit">
          <div class="button contract-submit-button" :class="{ 'is-inactive': paymentMethod.offerCodeRequestStatus === 3 && (paymentMethod.choosePaymentMethod === 901 || paymentMethod.choosePaymentMethod === 9) }">
            <button class="btn" type="submit" name="button" @click.prevent="paymentMethod.onSettingButtonClicked">
              <template v-if="props.parentName === 'EstimateFinalIndex'">お申し込み内容の確認</template>
              <template v-else-if="props.parentName === 'PCContract'">設定</template>
            </button>
          </div>
        </div>
      </template>

      <!-- 選択肢表示でない場合 -->
      <template v-else>
        <div class="column gutter">
          <div class="column-item col-12 space-gutter">

            <ul class="contract-content-list">
              <li class="contract-content-list-item">
                <table class="contract-content-table">
                  <tbody>
                    
                    <!-- 現在の支払情報 -->
                    <tr>
                      <th class="border-none">お支払い方法</th>
                      <td class="border-none">{{ paymentMethod.currentPaymentName }}</td>
                    </tr>
                    <!-- クレジットカードの場合 -->
                    <tr v-if="paymentMethod.defaultPayment === 1 || paymentMethod.defaultPayment === 2">
                      <th class="border-none">お支払い回数</th>
                      <td class="border-none">
                        <template v-if="paymentMethod.defaultPayment === 1">一括支払い</template>
                        <template v-else-if="paymentMethod.defaultPayment === 2">分割支払い</template>
                      </td>
                    </tr>

                    <!-- WEB請求書発行申請済み(authorization=true)で銀行振込に申込んでいる場合 -->
                    <tr v-if="paymentMethod.authorization && paymentMethod.examPaymentClassification === 7">
                      <th class="border-none">WEB請求書発行</th>
                      <td class="border-none">
                        <template v-if="paymentMethod.isWebInvoiceIssuanceApprovalAvailable">申請済み</template>
                        <template v-else>WEB請求書発行サービスをご提供できません。</template>
                      </td>
                    </tr>

                    <!-- WEB会員認証を実行した場合は、webuser_idに会員IDが設定されている -->
                    <tr v-if="paymentMethod.webuser_id !== ''">
                      <th class="border-none">申請いただいた新日本法規WEB会員ID</th>
                      <td class="border-none">{{ paymentMethod.webuser_id }}</td>
                    </tr>

                  </tbody>
                </table>
              </li>
            </ul>

            <div class="payment-result">

              <!-- 審査中 or 審査完了-->
              <template v-if="paymentMethod.authorization">
              
                <!-- クレジットカードに変更する場合 -->
                <template v-if="paymentMethod.examPaymentClassification === 1 || paymentMethod.examPaymentClassification === 2">
                  <template v-if="paymentMethod.lcRequestName === 'under_exam'">
                    <p class="fw-bold">クレジットカード{{ (paymentMethod.examPaymentClassification === 1) ? '一括' : '分割' }}決済の審査を行っております（申請日から3～7営業日）。審査終了まで追加購入、ライセンス追加購入は行えませんのでご了承ください。</p>
                    <p class="txt-sup">審査結果によって自動的にお支払い方法が切り替わります。</p>
                  </template>
                  <template v-else-if="paymentMethod.lcRequestName === 'examined'">
                    <p class="txt-sup">お支払いに使用するクレジットカードを変更する場合は、新日本法規WEBサイト「<a :href="URL_CREDIT_SETTING" class="txt-blue" target="_blank">LEGAL CONNECTIONクレジットカード設定</a>」で行えます。<br>
                    クレジットカードでのお支払いを停止する場合は、新日本法規WEBサイト「<a :href="URL_AUTOPAYMENT_CANCEL" class="txt-blue" target="_blank">LEGAL CONNECTION自動決済解約申請フォーム</a>」よりお申し付けください。</p>
                  </template>
                </template>

                <!-- 口座振替に変更する場合 -->
                <template v-else-if="paymentMethod.examPaymentClassification === 3">
                  <template v-if="paymentMethod.lcRequestName === 'under_exam'">
                    <p class="fw-bold">口座振替の審査を行っております（申請日から1～2ヵ月）。審査終了まで追加購入、ライセンス追加購入は行えませんのでご了承ください。</p>
                    <p class="txt-sup">審査結果によって自動的にお支払い方法が切り替わります。</p>
                  </template>
                  <template v-else-if="paymentMethod.lcRequestName === 'examined'">
                    <p class="txt-sup">口座振替でのお支払いを停止する場合は、新日本法規WEBサイト「<a :href="URL_AUTOPAYMENT_CANCEL" class="txt-blue" target="_blank">LEGAL CONNECTION自動決済解約申請フォーム</a>」よりお申し付けください。</p>
                  </template>
                </template>

                <!-- 銀行振込(WEB請求書発行)に変更する場合 -->
                <template v-else-if="paymentMethod.examPaymentClassification === 7">
                  <template v-if="paymentMethod.lcRequestName === 'under_exam'">
                    <p class="fw-bold">WEB請求書発行の審査を行っております（申請日から3～5営業日）。</p>
                    <p class="txt-sup">審査結果によって自動的にお支払い方法が銀行振込に切り替わります。</p>
                  </template>
                  <template v-else-if="paymentMethod.lcRequestName === 'examined'">
                    <p class="txt-sup">WEB請求書発行を停止する場合は、新日本法規WEBサイト「<a :href="URL_WEB_INVOICE_CANCEL" class="txt-blue" target="_blank">LEGAL CONNECTION WEB請求書解約申請フォーム</a>」よりお申し付けください。</p>
                  </template>
                </template>

              </template>

              <!-- 当月購入済みかつ未申請or却下 -->
              <template v-else>
                <p class="fw-bold">当月購入済みのため、お支払い方法は変更できません。</p>

                <!-- 当月購入済みかつ未申請（銀行振込）（default_paymentで判断） -->
                <template v-if="paymentMethod.defaultPayment === 7">
                    <p class="txt-sup">
                      銀行振込でのお支払いです。WEB請求書発行サービスをご利用いただけます。<br>
                      <a v-if="paymentMethod.isWebInvoiceIssuanceApprovalAvailable"
                        @click="paymentMethod.openWebInvoiceIssuanceApprovalWindow" 
                        class="txt-blue" role="button">WEB請求書発行(PDF)を有効にする</a>
                    </p>
                </template>

              </template>
  
              <template v-if="props.parentName === 'PCContract' && paymentMethod.isInvoicingInformationAvailable">
                <p class="ta-center">各商品のお支払い予定は<router-link to="/pc/contract-invoicing-information" class="txt-blue">ご請求案内</router-link>をご覧ください。</p>
              </template>
            </div>

          </div>
        </div>

        <div v-if="props.parentName === 'EstimateFinalIndex'" class="contract-submit">
          <div class="button contract-submit-button">
            <button class="btn" type="submit" name="button" @click.prevent="paymentMethod.onSettingButtonClicked">
              <template>お申し込み内容の確認</template>
            </button>
          </div>
        </div>

      </template>

    </template>

  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { ContractAccountPaymentMethod } from '@/logic/contract/ContractAccountPaymentMethod'

import { getConstants } from '@/util/constants'

export default defineComponent({
  props: {
    // 呼び出し元の名前
    parentName: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {

    const { URL_CREDIT_SETTING, URL_AUTOPAYMENT_CANCEL, URL_WEB_INVOICE_CANCEL, URL_WEB_AUTO_PAYMENT_SERVICE } = getConstants()

    return {
      URL_CREDIT_SETTING, 
      URL_AUTOPAYMENT_CANCEL,
      URL_WEB_INVOICE_CANCEL,
      URL_WEB_AUTO_PAYMENT_SERVICE,
      props,
      ...ContractAccountPaymentMethod(props, context)
    }
  }
})

</script>

<style lang="scss" scoped>
.contract-content {
  .button .btn[type="submit"] {
    width: 230px;
    margin: 32px auto 0;
  }
  &-list {
    list-style: none;
    &-item {
      border-top: 1px solid $color-line;
      padding: 20px 0 0;
    }
  }
  .hdg03{
    margin: 62px 0 15px;
  }
  .txt {
    line-height: 1.625;
  }
  &-payment {
    border-top: 1px solid $color-line;
    padding: 32px 0;
    .txt{
      margin-bottom: 32px;
    }
    .txt-notice {
      color: $color-notice;
      margin-top: 5px;
    }
    .formparts + .formparts{
      margin-top: 26px;
    }
    .formparts {
      &-indent {
        padding-left: 30px;
      }
    }
    label {
      font-weight: bold;
    }
    .txt-sup {
      margin-top: 5px;
    }

    &-flex {
      display: flex;
      .flex-content {
        margin-right: 20px;
      }
    }

    .iframe {
      display: block;
      width: 100%;
      max-width: 768px;
      border: 1px solid $color-line;
      margin-left: auto;
      margin-right: auto;
      &.-creditCard {
        height: 702px;
      }
      &.-bankTransfer {
        height: 500px;
      }
    }

    .section-suggest {
      padding: 48px 32px;
      border-radius: 4px;
      background-color: #F9F8F6;
      &-content {
        padding-top: 32px;
        border-top: 1px solid #DDD;
      }
      .txt-error {
        color: $color-errorbox;
        margin-top: 5px;
      }
    }

  }
  &-table {
    width: 100%;
    border-collapse: collapse;
    .border-none {
      border: 0!important;
    }
    &.border-bottom {
      border-bottom: 1px solid $color-line;
    }
    tbody {
      th,td {
        width: 50%;
        vertical-align: top;
        padding: 10px 15px 10px 0;
        border-top: 1px solid $color-line;
        font-size: 1.6rem;
        line-height: 1.625;
        text-align: left;
      }
      th {
        color: $color-hdg;
      }
    }
    &-link {
      font-size: 1.6rem;
      color: $color-link;
    }
  }
  .payment-result {
    margin-top: 40px;
    &:first-child {
      margin-top: 0;
    }
    .txt-sup{
      margin-top: 20px;
    }
    .ta-center{
      margin-top: 60px;
    }
  }
  .contract-submit {
    width: 230px;
    margin: 0 auto;
  }
  .login-btn-wrp {
    width: 230px;
    margin: 0 auto;
    .login-btn {
      border: 0;
      background-color: #005BAC !important;
      color: #FFF !important;
    }
  }
  .offer-code {
    text-align: center;
    &-title {
      margin-bottom: 10px;
    }
    &-input {
      height: 48px;
      width: 50%;
      border: 1px solid #ddd;
    }
    &-btn {
      height: 48px;
      margin-left: 10px;
      display: inline-block;
      width: 230px;
      border: 1px solid #ddd;
      color: #005BAC !important;
    }
  }
}
</style>
